import { useEffect, useState } from 'react';

import styles from '../../containers/app/App.scss';

const useLockScroll = () => {
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    document.body.classList.toggle(styles.overflowHidden, isLocked);

    return () => {
      document.body.classList.remove(styles.overflowHidden);
    };
  }, [isLocked]);

  return setIsLocked;
};

export default useLockScroll;
